import React, { memo } from 'react';
import { Title, TitlePreset } from '@pegasus/ui-components/components/title';
import {
    Text,
    TextPreset,
    ShadeColor,
} from '@pegasus/ui-components/components/text';
import { Wrapper } from './ModalHeader.styles';

interface FormHeaderProps {
    title: JSX.Element;
    subtitle?: JSX.Element;
}
const ModalHeader = memo(({ title, subtitle }: FormHeaderProps) => {
    return (
        <Wrapper>
            <Title preset={TitlePreset.M} className="header">
                {title}
            </Title>
            {subtitle && (
                <Text preset={TextPreset.M} color={ShadeColor.dark60}>
                    {subtitle}
                </Text>
            )}
        </Wrapper>
    );
});

export default ModalHeader;
